<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  <div class="hide-class">
    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2(v-if="phoneCode && phoneNumber" v-html="$t('h2', { prefix: phoneCode, number: phoneNumber})")

      h2(v-if="!phoneCode && !phoneNumber" v-html="$t('h2_2')")
      router-link.link-btn.enter-number(v-bind:to={'name': 'enter-number'}) {{ $t('enter-number') }}  
    form-check-code
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

import formCheckCode from '../form-enter-sms-code/component';
import formForgotPassword from '../form-forgot-password/component';

export default {
  name: 'PhoneNumberComponent',
  components: {
    formCheckCode,
    formForgotPassword,
  },
  data() {
    return {
      test: '&mdash;',
    };
  },
  computed: {
    ...mapGetters('registration', ['phoneCode', 'phoneNumber']),
  },
};
</script>

<style scoped>
.forgot-password {
  margin-top: 16px;
}
</style>
